import { Typography } from '../typography/typography';
import { useBreakpoints } from '@design-system/breakpointsStore';

export type ModalTypographyProps = {
  title?: string;
  description?: string;
  largeTitle?: boolean;
  className?: string;
};

export const ModalTitle = (
  p: Pick<ModalTypographyProps, 'title' | 'largeTitle' | 'className'>,
) => {
  const mobile = useBreakpoints((s) => s.mobile);

  return (
    <Typography
      variant="headline"
      color="B-100"
      size={p.largeTitle && !mobile ? 'large' : 'medium'}
      className={p?.className}
    >
      {p.title}
    </Typography>
  );
};

export const ModalDescription = (
  p: Pick<ModalTypographyProps, 'description' | 'className'>,
) =>
  p.description ? (
    <Typography
      variant="body"
      size="large"
      color="B-100"
      className={p?.className}
    >
      {p.description}
    </Typography>
  ) : null;
